module.exports = __webpack_public_path__ + "img/solution1.22cd10b9.png";